// extracted by mini-css-extract-plugin
module.exports = {"cell":"TemplateCardSkeleton_cell__1asDd","cellFit":"TemplateCardSkeleton_cellFit__PwUMR","shine":"TemplateCardSkeleton_shine__WzJ7_"};